import{css as o}from"lit";var e=o`
  .form-control {
    display: flex;
    flex-direction: column;
  }

  .form-control .form-control__label {
    display: none;
  }

  .form-control .form-control__help-text {
    display: none;
  }

  /* Label */
  .form-control--has-label .form-control__label {
    order: 1;
    display: inline-block;
    max-width: fit-content;
    color: var(--he-type-primary);
    cursor: pointer;
    font-size: var(--he-form-control-label-font-size);
    line-height: var(--he-line-height-normal);
    font-weight: var(--he-font-weight-semibold);
    margin-bottom: var(--he-spacing-2x-small);
  }

  .form-control--has-label.form-control--medium .form-control__label {
    font-size: var(--he-form-control-font-size);
  }

  :host([required]) .form-control--has-label .form-control__label::after {
    content: var(--he-form-control-required-content);
    margin-inline-start: var(--he-form-control-required-content-offset);
  }

  /* Help text */
  .form-control--has-help-text .form-control__help-text {
    order: 2;
    display: block;
    color: var(--he-type-primary);
    font-size: var(--he-form-control-help-text-font-size);
    font-weight: var(--he-font-weight-normal);
    line-height: var(--he-line-height-normal);
    margin-bottom: var(--he-spacing-x-small);
  }

  .form-control--has-help-text .form-control__help-text ::slotted(*) {
    margin-top: var(--he-spacing-3x-small);
  }

  /* Input */
  .form-control-input {
    order: 3;
    font-size: var(--he-form-control-font-size);
    font-weight: var(--he-font-weight-normal);
    line-height: var(--he-line-height-normal);
  }

  /* Error text */
  .form-control__error-text {
    display: none;
    order: 4;
    color: var(--he-form-control-error-color);
    font-size: var(--he-form-control-help-text-font-size);
    font-weight: var(--he-font-weight-normal);
    line-height: var(--he-line-height-normal);
    margin-top: var(--he-spacing-2x-small);
  }

  .form-control--has-interaction.form-control--has-error .form-control__error-text {
    display: block;
  }
`;export{e as a};
